import React,{useState,useEffect} from 'react';
import 'leaflet/dist/leaflet.css';
import './PopupRSU.css';

const PopupRSU = (props) => {

    const { name, communicationStatus, operationStatus, communicationStatusColor, operationStatusColor } = props;

    var link = "/#/meteo";

    //Deshabilitar el link si no hay pantalla de inversor
    const screen = JSON.parse(sessionStorage.getItem('ScreenConfiguration')).filter(screen => screen.Screen === "Meteo");
    const [hrefDisabled,setHrefDisabled] = useState(<></>);

    useEffect(() => {
        if(screen[0].Enabled === false){
            setHrefDisabled(<a className='a-ver-rsu'>{name}</a> )
        }else{
            setHrefDisabled(<a className='a-ver-rsu' href={link}>{name}</a>)
        }
    },[]);

    return (
        <div className='container-fluid' style={{width: 'max-content', padding: '0px'}}>
            <div className='row justify-content-center mb-3'>
                <div className='col-auto'>
                    {hrefDisabled}
                </div>
            </div>
            <div className='row' style={{margin: '5px'}}>
                <div className='col'>Estado operación: <strong style={{color: operationStatusColor}}>{operationStatus}</strong></div>
            </div>
            <div className='row' style={{margin: '5px'}}>
                <div className='col'>Estado comunicación: <strong style={{color: communicationStatusColor}}>{communicationStatus}</strong></div>
            </div>
        </div>
    );
};

export default PopupRSU;